module.exports = __webpack_public_path__ + "img/logo.f5098d40.svg";